import Alert from '../../components/tailwind/Alert';
import { useSelector } from 'react-redux';

const CartHeader = () => {
  const { message, type, duration } = useSelector((state: any) => state.cartAlert);

  return (
    <Alert show={!!message} duration={duration} type={type} className='tw:mt-2'>
      {message}
    </Alert>
  );
};

export default CartHeader;
